var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenSellIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20V12H17C17.5304 12 18.0391 12.2107 18.4142 12.5858C18.7893 12.9609 19 13.4696 19 14C19 14.5304 18.7893 15.0391 18.4142 15.4142C18.0391 15.7893 17.5304 16 17 16C17.5304 16 18.0391 16.2107 18.4142 16.5858C18.7893 16.9609 19 17.4696 19 18C19 18.5304 18.7893 19.0391 18.4142 19.4142C18.0391 19.7893 17.5304 20 17 20H14Z",
    stroke: "url(#paint0_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16H17",
    stroke: "url(#paint1_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V10",
    stroke: "url(#paint2_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20V22",
    stroke: "url(#paint3_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6V2",
    stroke: "url(#paint4_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V2",
    stroke: "url(#paint5_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6V2",
    stroke: "url(#paint6_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30V26",
    stroke: "url(#paint7_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30V26",
    stroke: "url(#paint8_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30V26",
    stroke: "url(#paint9_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H30",
    stroke: "url(#paint10_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H30",
    stroke: "url(#paint11_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22H30",
    stroke: "url(#paint12_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H6",
    stroke: "url(#paint13_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H6",
    stroke: "url(#paint14_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H6",
    stroke: "url(#paint15_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H10C7.79086 6 6 7.79086 6 10V22C6 24.2091 7.79086 26 10 26H22C24.2091 26 26 24.2091 26 22V10C26 7.79086 24.2091 6 22 6Z",
    stroke: "url(#paint16_linear_9346_135290)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9346_135290",
    x1: 16.5,
    y1: 12,
    x2: 16.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9346_135290",
    x1: 15.5,
    y1: 16,
    x2: 15.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9346_135290",
    x1: 16.5,
    y1: 10,
    x2: 16.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9346_135290",
    x1: 16.5,
    y1: 20,
    x2: 16.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9346_135290",
    x1: 10.5,
    y1: 2,
    x2: 10.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9346_135290",
    x1: 16.5,
    y1: 2,
    x2: 16.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9346_135290",
    x1: 22.5,
    y1: 2,
    x2: 22.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9346_135290",
    x1: 10.5,
    y1: 26,
    x2: 10.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9346_135290",
    x1: 16.5,
    y1: 26,
    x2: 16.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9346_135290",
    x1: 22.5,
    y1: 26,
    x2: 22.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9346_135290",
    x1: 28,
    y1: 10,
    x2: 28,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9346_135290",
    x1: 28,
    y1: 16,
    x2: 28,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9346_135290",
    x1: 28,
    y1: 22,
    x2: 28,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9346_135290",
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9346_135290",
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9346_135290",
    x1: 4,
    y1: 22,
    x2: 4,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_9346_135290",
    x1: 16,
    y1: 6,
    x2: 16,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0FF3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSellIcon1);
export default __webpack_public_path__ + "static/media/token-sell-icon1.77b0d9ba8e41eea65bfc15d113c3dae0.svg";
export { ForwardRef as ReactComponent };